import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function NextInspectionIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M14 5.04938V4H8V6H6V4H3V18C3 18.5513 3.44824 19 4 19H5.83209C6.14405 19.714 6.53698 20.3845 6.99927 21H4C2.3457 21 1 19.6543 1 18V2H6V1H8V2H14V1H16V2H21V6.99927C20.3845 6.53698 19.714 6.14405 19 5.83209V4H16V5.04938C15.6711 5.01672 15.3375 5 15 5C14.6625 5 14.3289 5.01672 14 5.04938Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M14 11V16.125L19.0001 18.1716V16.0102L16 14.7832V11H14Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 23C19.4183 23 23 19.4183 23 15C23 10.5817 19.4183 7 15 7C10.5817 7 7 10.5817 7 15C7 19.4183 10.5817 23 15 23ZM15 21C18.3137 21 21 18.3137 21 15C21 11.6863 18.3137 9 15 9C11.6863 9 9 11.6863 9 15C9 18.3137 11.6863 21 15 21Z",
    fill: "currentColor"
  }));
}